module.exports = __webpack_public_path__ + "63c82f531e16894bcb547bcd7d5b8ee4.png";